import apiClient from '../services/apiClient';
import mapper from '@/services/order/mapper';

export default {
	namespaced: true,
	state: {
		orderDropship: {
			amount: 0,
			orders: [],
		},
	},
	getters: {
		orders(state) {
			return state.orderDropship.orders;
		},
	},
	mutations: {
		SET_ORDERS(state, orders) {
			state.orderDropship.orders = mapper.mapOrders(orders);
		},
		SET_ORDER_AMOUNT(state, amount) {
			state.orderDropship.amount = amount
		},
	},
	actions: {
		async init({commit, state}, getRequirements) {
			return new Promise((resolve, reject) => {
				const params = {
					...getRequirements,
					filter: ['drop_ship', 'not_done', 'not_cancelled'],
				};

				apiClient.get('orders/get', {params}).then(res => {
					commit('SET_ORDERS', res.data.orders);
					commit('SET_ORDER_AMOUNT', res.data.ordersCount);

					resolve();
				}).catch(err => {
					reject();
				})
			});
		},
	}
}
